import { render, staticRenderFns } from "./PatientRecord.vue?vue&type=template&id=75939d0f"
import script from "./PatientRecord.vue?vue&type=script&lang=js"
export * from "./PatientRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports